import type { MainNavigationGroupItem } from "components/MainNavigation/types";
import useMainNavigationDropdownManager from "components/MainNavigation/hooks/useDropdownManager";

import MainNavigationDropdownMenuItems, {
  MainNavigationDropdownMenuItemsProps,
} from "../../atoms/DropdownMenu/Items";
import MainNavigationDropdownMenu, {
  MainNavigationDropdownMenuProps,
} from "../../atoms/DropdownMenu";

export type MainNavigationDropdownGroupItemProps = {
  group: MainNavigationGroupItem;
  triggerComponent: MainNavigationDropdownMenuProps["triggerComponent"];
  menuItemsCustomRenderers?: MainNavigationDropdownMenuItemsProps["customRenderers"];
  className?: string;
  withGroupTitle?: boolean;
};

const MainNavigationDropdownGroupItem = ({
  group,
  triggerComponent,
  menuItemsCustomRenderers,
  className,
  withGroupTitle = false,
}: MainNavigationDropdownGroupItemProps) => {
  const { isOpen, dropdownId, closeDropdown } = useMainNavigationDropdownManager(group.id);

  return (
    <MainNavigationDropdownMenu
      dropdownId={dropdownId}
      isOpen={isOpen}
      triggerComponent={triggerComponent}
      className={className}
    >
      <MainNavigationDropdownMenuItems
        group={group}
        closeDropdown={closeDropdown}
        customRenderers={menuItemsCustomRenderers}
        withGroupTitle={withGroupTitle}
      />
    </MainNavigationDropdownMenu>
  );
};

export default MainNavigationDropdownGroupItem;
